import { create } from "zustand";

export enum ModalType {
  // One screen for every way a lesson can begin. The three it replaced
  // (INITIALIZATION, RESUME_RESTART, LEARN_AGAIN) differed only in their
  // buttons, which are now data — see SessionStartModal.
  SESSION_START = "SESSION_START",
  CHANGE_LANGUAGE = "CHANGE_LANGUAGE",
  CHANGE_CHARACTER = "CHANGE_CHARACTER",
  CHANGE_VOICE = "CHANGE_VOICE",
  ERROR = "ERROR",
  MIC_PERMISSION = "MIC_PERMISSION",
  MIC_SILENCE_TEST = "MIC_SILENCE_TEST",
}

interface ModalState {
  modal: ModalType | null;
  modalProps?: any;
  openModal: (type: ModalType, props?: any) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  modal: null,
  modalProps: {},
  openModal: (type, props) => set({ modal: type, modalProps: props }),
  closeModal: () => set({ modal: null, modalProps: {} }),
}));
